export const CORE_QA_TOOLBOX_SCRIPT_ID = 'zep-core-qa-toolbox-bootstrap';
export const CORE_QA_TOOLBOX_BOOTSTRAP_PATH = '/__dev/qa/core/bootstrap.js';
export const CORE_QA_TOOLBOX_SPACE_REFRESH_EVENT =
  'zep:core-qa-toolbox-refresh-space';

const CORE_QA_TOOLBOX_SPACE_REFRESH_DELAY_MS = 600;

const DEV_HOST_PATTERN = /^dev(?:-[2-6])?\.zep\.us$/;

export function isCoreQaToolboxEnvironment(
  stage: string | undefined,
  hostname: string | undefined,
): boolean {
  return (
    stage === 'DEV' && Boolean(hostname && DEV_HOST_PATTERN.test(hostname))
  );
}

export function getCoreQaToolboxBootstrapPath(pathname: string): string {
  return pathname === '/play' || pathname.startsWith('/play/')
    ? `/play${CORE_QA_TOOLBOX_BOOTSTRAP_PATH}`
    : CORE_QA_TOOLBOX_BOOTSTRAP_PATH;
}

export function appendCoreQaToolboxBootstrap(
  document: Document,
  pathname: string,
): HTMLScriptElement | null {
  if (document.getElementById(CORE_QA_TOOLBOX_SCRIPT_ID)) return null;

  const script = document.createElement('script');
  script.id = CORE_QA_TOOLBOX_SCRIPT_ID;
  script.async = true;
  script.src = getCoreQaToolboxBootstrapPath(pathname);
  script.dataset.coreQaToolbox = 'true';
  script.addEventListener('error', () => {
    script.remove();
  });

  document.head.appendChild(script);
  return script;
}

export function addCoreQaToolboxSpaceRefreshListener(
  target: Window,
  reload: () => void,
): () => void {
  let timeoutId: number | null = null;
  const listener = (event: Event) => {
    const detail = (event as CustomEvent<{ spaceHashId?: unknown }>).detail;
    if (
      !detail ||
      typeof detail.spaceHashId !== 'string' ||
      detail.spaceHashId.length === 0
    ) {
      return;
    }
    if (timeoutId !== null) target.clearTimeout(timeoutId);
    timeoutId = target.setTimeout(
      reload,
      CORE_QA_TOOLBOX_SPACE_REFRESH_DELAY_MS,
    );
  };

  target.addEventListener(CORE_QA_TOOLBOX_SPACE_REFRESH_EVENT, listener);
  return () => {
    target.removeEventListener(CORE_QA_TOOLBOX_SPACE_REFRESH_EVENT, listener);
    if (timeoutId !== null) target.clearTimeout(timeoutId);
  };
}
